
import { IFormActions, IFormState } from "@ngt/forms-core";
import { MouseEvent, useMemo } from "react";
import FormActionButton, { IFormActionButtonProps } from "./FormActionButton";

export interface IFormSubmitButtonProps<T extends object = any> extends Omit<IFormActionButtonProps<T>, 'onClick'> {
    onClick?: IFormActionButtonProps<T>['onClick']
    
}

const defaultSubscription = { submitting: true, validating: true };

const FormSubmitButton = <T extends object = any>({
    onClick,
    loading,
    loadingSubscription,
    ...rest
}: IFormSubmitButtonProps<T>) => {
    const click = useMemo(() => {
        if (!onClick) {
            return (_: MouseEvent<HTMLButtonElement>, actions: IFormActions) => {
                actions.submit();
            };
        }

        return onClick
    }, [onClick]);

    const loadingToUse = useMemo(() => {
        if (loading != undefined) {
            return loading;
        }

        return (formState: IFormState<T, string>) => {
            return formState.submitting || formState.validating;
        };
    }, [loading])

    return (
        <FormActionButton
            {...rest}
            onClick={click}
            loading={loadingToUse}
            loadingSubscription={loading !== undefined || !!loadingSubscription ? loadingSubscription : defaultSubscription}
        />
    )
};

export default FormSubmitButton;